import { Prop, Component, Watch, Vue } from "vue-property-decorator";

interface IRoot {
    roles: string[];
}

declare module "vue/types/vue" {
    interface Vue {
        auth: IRoot;
    }
}

Vue.mixin({
    computed: {
        auth(): any { return this.$root; },
    }
});

export { Vue, Component, Prop, Watch };
